import { createSlice } from "@reduxjs/toolkit";
import { registerCourse } from "services/student/student";

const initialState = {
    student : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}
export const registerCourseSlice = createSlice({
    name: 'registerCourse',
    initialState,
    extraReducers: {
        [registerCourse.pending]: (state) => {
            state.student.isLoading = true;
        },
        [registerCourse.fulfilled]: (state, { payload }) => {
            state.student.isLoading = false;
            state.student.isSuccess = true;
            state.student.data = payload;
        },
        [registerCourse.rejected]: (state, { payload }) => {
            state.student.isLoading = false;
            state.student.isSuccess = false;
            state.student.errorMessage = payload
        }
    }
})
export default registerCourseSlice.reducer;